import { mxConfig } from '../config';
import { hotjar } from 'react-hotjar';

if (mxConfig.hotjarId) {
  hotjar.initialize(mxConfig.hotjarId, 6);
}
